import classNames from 'classnames'

import * as styles from './GretaAIChatSourceSweep.module.css'

function GretaAIChatSourceSweep({ isFinance = false }) {
  return (
    <span
      aria-hidden
      className={classNames(styles.sweep, { [styles.toCrm]: !isFinance })}
    />
  )
}

export default GretaAIChatSourceSweep
